import script from "./ContentPacksList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPacksList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__